import { persistentAtom } from '@nanostores/persistent'

type ThemeStoreInfo = {
  mode?: 'legacy' | undefined
}

export const themeStore = persistentAtom<ThemeStoreInfo>(
  'theme',
  { mode: 'legacy' },
  {
    encode: JSON.stringify,
    decode: JSON.parse,
  }
)

